import React, { useState, useEffect } from 'react';
import { Wallet, initMercadoPago } from '@mercadopago/sdk-react';
import axios from '../../../middleware/axios';
import { UserType } from '../../../models/user_model';
import { CartProductItem } from '../../../models/cart_model';
import { UserDeliveryData } from '../../../models/user_model';
import { OrderType } from '../../../models/order_model';
import { db } from '../../../middleware/firebase';

initMercadoPago(process.env.REACT_APP_MP_KEY!);

type WalletBrickProps = {
  total: number;
  user: UserType;
  products: CartProductItem[];
  deliveryData: UserDeliveryData;
  shipping: number;
  cart_id?: string;
  setOrderObject: () => OrderType;
};

const WalletBrick: React.FC<WalletBrickProps> = ({ total, user, products, deliveryData, shipping, cart_id, setOrderObject }) => {
  const [preferenceId, setPreferenceId] = useState<string | null>(null);

  useEffect(() => {
    const createPreference = async () => {
      // Build the order object so it can be saved before redirect
      const orderData = setOrderObject();

      // Save user.id in sessionStorage for the return handler
      const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
      sessionStorage.setItem('mp_wallet_user_id', currentUser.id);

      // Save order data to Firestore before creating preference
      try {
        await db
          .collection('cart')
          .doc(currentUser.id)
          .collection('mp_wallet_order')
          .doc('pending')
          .set(orderData);
      } catch (error) {
        console.log('mpWallet.tsx | Error saving order data:', error);
      }

      const response = await axios.post('/scriptsPaymentsMpCreatePreference', {
        body: {
          total,
          user,
          products,
          deliveryData,
          shipping,
          cart_id,
          orderData,
          origin: window.location.origin,
        }
      });

      if (response.data.id) {
        setPreferenceId(response.data.id);
      }
    };

    createPreference();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!preferenceId) {
    return <div>Cargando...</div>;
  }

  return (
    <Wallet
      initialization={{ preferenceId }}
      customization={{
        texts: {
          valueProp: 'smart_option',
        },
      }}
    />
  );
};

export default WalletBrick;
